import { render } from "./ProjectNotificationPage.vue?vue&type=template&id=2ab6cb42&scoped=true&ts=true"
import script from "./ProjectNotificationPage.vue?vue&type=script&lang=ts"
export * from "./ProjectNotificationPage.vue?vue&type=script&lang=ts"

import "./ProjectNotificationPage.vue?vue&type=style&index=0&id=2ab6cb42&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab6cb42"]])

export default __exports__